import React from 'react';
import { ApplicationContext } from '../../../contexts/ApplicationContext';
import { IBank } from '../../../models';
import { SelectionMode } from '@fluentui/react/lib/Selection';
import { CheckboxVisibility, IColumn } from '@fluentui/react/lib/DetailsList';
import FreezableDetailsList from '../../../components/FreezableDetailsList';
import { DefaultButton, ICommandBarItemProps, SearchBox } from '@fluentui/react';
import styles from '../../../styles/App.module.scss';
import ListComponent from '../../../components/ListComponent';
import useObject from '../../../hooks/useObject';
import { FormMode } from '../../../utils/Enums';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import BanksPanel from './BanksPanel';
import ErrorDialog from '../../../components/ErrorDialog';

interface IBanksProps
{

}

export const Banks: React.FunctionComponent<IBanksProps> = (props: React.PropsWithChildren<IBanksProps>) => {
  const navigate: NavigateFunction = useNavigate();    
  const { Services } = React.useContext(ApplicationContext);
    const [items, setItems] = React.useState<IBank[]>([]);  
    const [allItems, setAllItems] = React.useState<IBank[]>([]);  
    const [selected, setSelected] = React.useState<IBank | undefined>(undefined);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [showPanel, setShowPanel] = React.useState<boolean>(false);
    const { value: entity, updateValue: updateEntity, setValue } = useObject<IBank>({ regNo: 0, name: ""} as IBank);
    const [formMode, setFormMode] = React.useState<FormMode>(FormMode.New);
    const [errorDialogText, setErrorDialogText] = React.useState<string>('');
    const [showErrorDialog, setShowErrorDialog] = React.useState<boolean>(false);

    const openErrorDialog = (message: string) => {
      setErrorDialogText(message);
      setShowErrorDialog(true);
    };

    React.useEffect(() => {    
        Fetch();
      }, []);

      React.useEffect(() => {
        setValue(selected as IBank);
      }, [selected]);

    const Fetch = async () => {
    Services?.Bank.GetAll().then((result: IBank[]) => {          
        setIsLoading(true);
        setItems(result);
        setAllItems(result);
        setIsLoading(false);
      }); 
}

      const COMMANDBAR_COLUMNS = [
        {
          key: 'regNo',
          name: 'Reg. nr.',
          fieldName: 'regNo',
          minWidth: 100,
          maxWidth: 100,
          isResizable: true
        },
        {
          key: 'name',
          name: 'Navn',
          fieldName: 'name',
          minWidth: 150,
          maxWidth: 250,
          isResizable: true
        }
      ] as IColumn[];

      const Commands: ICommandBarItemProps[] = [
        {
            key: 'create',
            text: 'Opret',
            iconProps: { iconName: 'Add' },
            onClick: () => { 
                Reset(); setFormMode(FormMode.New); setShowPanel(true);
             },
            //disabled: selected != undefined
        }
        ];

      const CreateFarMenuItems = [
        {        
          key:"search",
          onRender:() => <SearchBox 
            placeholder="Søg efter ..." 
            className={styles.searchBox} 
            onSearch={(newValue) => { onSearch(newValue); } } 
            onChange={(event?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => { onSearch(newValue); }}
            onClear={ev => { onSearch(""); }}
            />
        }
      ];

      const onSearch = (searchTerm: string | undefined) => {
          setItems(searchTerm && searchTerm != "" ? filter(searchTerm) : allItems);
      }
          
              const filter = (searchTerm: string) : IBank[] => {
                return allItems.filter(i =>                   
                  (i.regNo + "").toLowerCase().indexOf(searchTerm.toLocaleLowerCase()) > -1 || 
                  (i.name + "").toLowerCase().indexOf(searchTerm.toLocaleLowerCase()) > -1
                );
              }

      const AddOrUpdate = async () =>
    {
        let result : string | undefined = undefined;
        
        switch(formMode)
        {
            case FormMode.New:
                result = await Services?.Bank.Create(entity);
                break;
            case FormMode.Edit:
                result = await Services?.Bank.Update(entity);
                break;
        }
        
        if(result === "OK")
        {
            Reset();
            Fetch();
        } else
        {
          openErrorDialog(result as string);
        }
    }

    const Reset = () => {
        setSelected(undefined);
        setShowPanel(false);
    }
    
    // Listen fylder den ledige højde og scroller selv, så "Tilbage" altid er synlig nederst
    return <div style={{display:"flex", flexDirection:"column"}}>
                <div style={{flex:1, minHeight:0}}>
                    <ListComponent title="Banker" commands={Commands} farItems={CreateFarMenuItems}>
                        <FreezableDetailsList
                        items={isLoading ? undefined as any : items}
                        columns={COMMANDBAR_COLUMNS}
                        selectionMode={SelectionMode.single}
                        checkboxVisibility={CheckboxVisibility.hidden}
                        enableClickRowOpen={true}
                        onSelectionChanged={(item: IBank | undefined) => {
                          if(item !== undefined) { setFormMode(FormMode.Edit); setSelected(item); setShowPanel(true); }
                        }}
                        />
                    </ListComponent>
                </div>
                <div style={{paddingTop:"10px"}}>
                    <DefaultButton text="Tilbage" onClick={() => { navigate("/indstillinger"); }} />
                </div>
                { showPanel && 
                    <BanksPanel selected={selected as IBank} formMode={formMode} onDismiss={(update: boolean) => {if(update) Fetch(); setShowPanel(false); }} />
                }
                <ErrorDialog
                  isOpen={showErrorDialog}
                  errorText={errorDialogText}
                  onDismiss={() => setShowErrorDialog(false)}
                />
           </div>
}

export default Banks;